
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import CommissionService from "@/services/auth/CommissionService";
import HeroService from "@/services/auth/HeroService";
import DateRangePicker from "vue2-daterange-picker";
import SquadService from "@/services/auth/SquadService";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { Money } from 'v-money';
import { Component, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import { mapGetters } from 'vuex'

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    Money,
    vSelect
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class ManagementHero extends Vue {

  private commissionService = new CommissionService();
  private heroService = new HeroService();
  private squadService = new SquadService();

  /**
   * @type Object
   * Data list lead from return backend
   */
  private metricHeroList: any;
  private squadList: any = [];

  /**
   * @type Object
   * insert commission
   */
  private hero: any = {
    platformId: this.$auth.user().id_platform,
    squad: null,
    date: null,
    itemsMetrics: null
  };

   private itemsMetrics: {
          level_name: string,
          level_label: string,
          csat: string,
          conversion: string,
          productive_contact: string,
    }[] = [];

  private fieldsMetrics = [
    { key: 'level_name', label: 'Level metrica' },
    { key: 'csat', label: 'CSAT' },
    { key: 'conversion', label: 'Conversão' },
    { key: 'productive_contact', label: 'Contatos finalizados' },
  ];

  private levelList = [
        { key:"quadrant_1", label: "Quadrante 1" },
        { key:"quadrant_2", label: "Quadrante 2" },
        { key:"quadrant_3", label: "Quadrante 3" },
        { key:"quadrant_4", label: "Hero" },
  ];

  private selectedQuadrante: {
    label: string;
    key: string;
  } | null = null;

  private selectedCSAT: string = '';
  private selectedProductiveContact: string = '';
  private selectedConversion: string = '';

  private percentMask: any = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '%',
    precision: 2,
    masked: true /* doesn't work with directive */
  }

  private dateHero = {
    startDate: "",
    endDate: ""
  }

  @Watch("dateHero.startDate")
  onChangeSaleDate(value: any, _oldValue: any) {
    this.hero.date = value;
  }

  private noMask: any = {
    masked: false,
    decimal: '',
    thousands: '',
    prefix: '',
    suffix: '',
    precision: 0,
  }

  /**
   * @type boolean
   * Help to control error message
   */
  private validatingCommissionNull: boolean = false;
  private validatingCommissionItensNull: boolean = false;
  private isHeroInvalid: boolean = false;
  private loading: boolean = false;

  /**
   * @tyoe Array
   * Define columns from datatables
   */
  private columns = [
    { data: "id_user_hero_metrics", name: "id_user_hero_metrics", title: "ID", orderable: true, searchable: true },
    { data: "name", name: "name", title: "Squad", orderable: true, searchable: true },
    { data: "actions", name: "actions", title: "Ações", orderable: true, searchable: true },
    { data: "level_label", name: "level_label", title: "Quadrante", orderable: true, searchable: true },
    { data: "csat", name: "csat", title: "CSAT", searchable: true },
    { data: "conversion_rate", name: "conversion_rate", title: "Conversão", searchable: true },
    { data: "productive_contact", name: "productive_contact", title: "Contatos finalizados", orderable: true, searchable: true },
    { data: "status", name: "status", title: "Status", orderable: true, searchable: true },
    { data: "date", name: "data", title: "Data", searchable: true }
  ];

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];

  /**
   * Method for add new commission
   */
  private async addHero() {
    this.validatingCommissionNull = true;
    if(!this.hero.date)
        return this.isHeroInvalid = true;

    if((this.$moment(this.hero.date) as any).format('YYYY-MM-DD') !== (this.$moment(this.hero.date) as any).startOf('month').format('YYYY-MM-DD'))
        return this.isHeroInvalid = true;

    if(!this.hero.squad)
        return this.isHeroInvalid = true;

    if(this.itemsMetrics.length < 4)
        return this.isHeroInvalid = true;

    this.itemsMetrics.map((e:any) => {
        e.conversion = parseFloat(e.conversion.replace("%", '').replace(",", "."));
    })

    this.hero.itemsMetrics = this.itemsMetrics;

    this.loading = true;
    try {
        await this.heroService.store(this.hero);
        this.loading = false;
        this.$store.commit("navBarAlert/SUCCESS_ALERT", "Metrica registrada com sucesso");
    } catch (error) {
        console.log(error);

        this.loading = false;
        this.$store.commit("navBarAlert/DANGER_ALERT", "Erro ao registrar Metrica");
    }

    this.metricHeroList.ajax.reload();
    this.closeHeroModal();
  }

  private addItem() {
    if (!this.selectedQuadrante)
      return this.validatingCommissionItensNull = true

    this.validatingCommissionItensNull = false;
    const duplicateTriggerIndex = this.itemsMetrics.findIndex(e => e.level_name == this.selectedQuadrante!.label);
    if (duplicateTriggerIndex >= 0)
        this.itemsMetrics.splice(duplicateTriggerIndex, 1);

    this.itemsMetrics.push(
        {
            level_name: this.selectedQuadrante.label,
            level_label: this.selectedQuadrante.key,
            csat: this.selectedCSAT || '0',
            conversion: this.selectedConversion  || '0',
            productive_contact: this.selectedProductiveContact || '0',
        }
    )

    this.selectedQuadrante = null;
    this.selectedProductiveContact = '';
    this.selectedCSAT = '';
    this.selectedConversion = '';
  }

  private closeHeroModal() {
    this.hideModal("modal-add-metric-hero");

    this.itemsMetrics = [];
    this.hero.platformId = this.$auth.user().id_platform,
    this.selectedProductiveContact = '';
    this.validatingCommissionNull = false;
    this.validatingCommissionItensNull = false;
    this.isHeroInvalid = false;
    this.selectedQuadrante = null;
    this.hero.date = null;
    this.hero.squad = null;
    this.dateHero = {
        startDate: "",
        endDate: ""
    }
  }

  private removeItemsTrigger(item, index, element) {
    this.itemsMetrics.splice(index, 1);
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable(vm) {

    if (vm.allowedFeature('management-commission'))
        this.buttons.push({ extend: "addHero" });

    this.metricHeroList = this.$('#metricHeroList').DataTable({
      autoWidth: false,
      scrollCollapse: true,
      paging: false,
      fixedColumns: true,
      responsive: true,
      processing: true,
      order: [[0, "desc"]],
      lengthMenu: [
        [25, 50, 100],
        [25, 50, 100],
      ],
      pageLength: 25,
      scrollY: 500,
      scrollX: true,
      searching: true,
      dom: '<"row"<"col-sm-12 col-md-5"l><"col-sm-12 col-md-7"f>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
      ajax: {
        url: process.env.VUE_APP_ROOT_API + "auth/heroes-rules/" + this.$auth.user().id_platform,
        dataSrc: "",
        crossDomain: true,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'));
        }
      },
      columnDefs: [
        {
            className: "nowrap",
            width: 200,
        }
      ],
      columns: this.columns,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ Qtd por página",
        sLoadingRecords: "Carregando...",
        sProcessing:
          '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
        sZeroRecords: "Nenhum registro encontrado",
        sSearch: "Pesquisar",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último"
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente"
        },
        select: {
          rows: {
            _: "Selecionado %d linhas",
            "0": "Nenhuma linha selecionada",
            "1": "Selecionado 1 linha"
          }
        }
      },
      buttons: this.buttons,
      drawCallback: () => {
        this.$(".editButton").click(e => {
          this.$bvModal.show("modal-add-metric-hero");
        });
      }
    });

    this.metricHeroList.buttons().container().appendTo("#dt-actions");
  }

  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;
    this.loading = true;

    this.$.fn.dataTable.ext.buttons.addHero = {
      text: '<i class="fas fa-plus"></i>',
      className: "datatable-buttons pr-0 pl-0",
      titleAttr: "Adicionar regra de Metrica",
      action: function (e, dt, node, config) {
        self.$bvModal.show("modal-add-metric-hero");
      }
    };

    this.squadList = await this.squadService.show(this.$auth.user().id_platform);
    try {
      this.createDataTable(self);
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }

  private get selectedQuadranteState() {
    return (!this.validatingCommissionItensNull && !this.selectedQuadrante ) ? null :
     (this.validatingCommissionItensNull && !this.selectedQuadrante) ? false : true;
  }

  private get dateHeroState() {
     return (!this.validatingCommissionNull && !this.hero.date) ? null :
     (this.validatingCommissionNull && !this.hero.date) ? false :
     ((this.$moment(this.hero.date) as any).format('YYYY-MM-DD') !== (this.$moment(this.hero.date) as any).startOf('month').format('YYYY-MM-DD')) ?
     false : true;
  }

  private get triggerTypeState() {
     return (!this.validatingCommissionNull && !this.hero.trigger_type ) ? null :
     (this.validatingCommissionNull && !this.hero.trigger_type) ? false : true;
  }

   private get squadState() {
     return (!this.validatingCommissionNull && !this.hero.squad ) ? null :
     (this.validatingCommissionNull && !this.hero.squad) ? false : true;
  }
}
